import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

export default function LoadingPage({
  redirectTo = "/welcome",
  duration = 2500,
}) {
  const navigate = useNavigate();
  const [expand, setExpand] = useState(false);

  useEffect(() => {
    const start = setTimeout(() => {
      setExpand(true);
    }, 1000);

    const redirect = setTimeout(() => {
      navigate(redirectTo);
    }, duration);

    return () => {
      clearTimeout(start);
      clearTimeout(redirect);
    };
  }, [navigate, redirectTo, duration]);

  return (
    <div className="light-page">
      <div className={`light-core ${expand ? "expand" : ""}`} />
      <div className="glow-layer" />

      <style>{`
        .light-page {
          position: fixed;
          inset: 0;
          overflow: hidden;
          background: black;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .light-core {
          position: absolute;
          width: 5px;
          height: 5px;
          border-radius: 50%;
          background: white;
          box-shadow:
            0 0 40px rgba(255,255,255,1),
            0 0 100px rgba(255,255,255,0.9),
            0 0 180px rgba(255,255,255,0.8);
          transform: scale(1);
          transition: transform 2.3s cubic-bezier(0.2, 0.8, 0.2, 1);
        }

        .light-core.expand {
          transform: scale(680);
        }

        .glow-layer {
          position: absolute;
          inset: 0;
          background:
            radial-gradient(circle, rgba(255, 255, 255, 0.25) 0%, transparent 70%);
          animation: pulse 5s ease-in-out infinite;
          pointer-events: none;
        }

        @keyframes pulse {
          0% {
            opacity: 0.4;
          }
          50% {
            opacity: 1;
          }
          100% {
            opacity: 1;
          }
        }
      `}</style>
    </div>
  );
}